import axios from "axios";
import store from "@/store";

let instance = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,
    timeout: 20000,
})
let w: any = window;

instance.interceptors.request.use((config: any)=> {
    if (config.url === '') {
        config.headers = {  // 登录 --- 需清空Authorization字段

        };
    } else {
        config.headers = {
            'Content-Type': 'application/json',
            'access-token': store.state.token,
        }
    }
    return config;
},(error)=> {
    return Promise.reject(error);
});

//拦截
instance.interceptors.response.use((response) => {
    if (response.status == 200 &&
        !response.data.success) {
    }
    return response;
}, (error) => {
    
    return Promise.reject(error.response);
});

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
async function get(url: any, params: any) {
    return instance.get(url, params);
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} data [请求时携带的参数] 
 */
async function post(url: any, data: any) {
    return instance.post(url, data);
}

export default {
    get,
    post
}